import { render } from "./ProductStockDetails.vue?vue&type=template&id=05cba459"
import script from "./ProductStockDetails.vue?vue&type=script&lang=js"
export * from "./ProductStockDetails.vue?vue&type=script&lang=js"
script.render = render

export default script